var _path, _path2, _path3, _g, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.378e-06 89.9998V295C-0.00131202 299.765 0.936261 304.485 2.75879 308.888C4.58132 313.291 7.25316 317.293 10.6221 320.664C13.991 324.034 17.9909 326.708 22.3933 328.533C26.7957 330.358 31.5144 331.298 36.28 331.3H228.79C233.564 331.304 238.292 330.366 242.702 328.54C247.113 326.715 251.121 324.037 254.495 320.661C257.87 317.284 260.545 313.275 262.368 308.863C264.192 304.452 265.127 299.723 265.12 294.95V36.3097C265.12 31.5419 264.181 26.8208 262.356 22.416C260.531 18.0112 257.856 14.0091 254.485 10.6382C251.113 7.26729 247.11 4.59368 242.705 2.77002C238.299 0.946363 233.578 0.00845355 228.81 0.009767H90.02L18.8401 71.1597L1.378e-06 89.9998Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9998L18.8401 71.1597L90.02 0.009767H228.79C233.558 0.00845355 238.279 0.946363 242.685 2.77002C247.09 4.59368 251.093 7.26729 254.465 10.6382C257.836 14.0091 260.511 18.0112 262.336 22.416C264.161 26.8208 265.1 31.5419 265.1 36.3097V120.67H0V89.9998Z",
    fill: "#50984B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.0002L44.4302 99.8102C53.8598 101.757 63.6767 99.8788 71.7217 94.5886C79.7667 89.2984 85.381 81.0294 87.3301 71.6002L89.1802 61.4102C88.5954 64.2189 87.6615 66.9433 86.4001 69.5201C83.4317 75.6586 78.7931 80.8361 73.0164 84.4585C67.2396 88.0809 60.5588 90.0016 53.7402 90.0002H0Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90H53.7402C60.5588 90.0014 67.2396 88.0807 73.0164 84.4583C78.7931 80.8358 83.4317 75.6584 86.4001 69.5199C87.6615 66.9431 88.5954 64.2186 89.1802 61.4099C89.7418 58.8752 90.02 56.2861 90.01 53.6899V0L18.8401 71.1599L0 90Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.26 273.26H45.8398V176.19H219.26V273.26ZM56.97 262.12H208.12V187.32H56.97V262.12Z",
    fill: "#50984B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.73 181.75H94.5898V267.69H105.73V181.75Z",
    fill: "#50984B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.688 219.15H51.3984V230.29H213.688V219.15Z",
    fill: "#50984B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.4b2f97c6bb4412915c61eac6272d7ec9.svg";
export { ForwardRef as ReactComponent };